<template>
  <router-view />
</template>

<script>
export default {
  name: "MiniMetodeCatalogPage",
};
</script>
